import "./ErrorPage.scss";

import FloatingButton from "../Shared/FloatingButton/FloatingButton";
import { GlobalState } from "../../redux/store";
import { Link } from "react-router-dom";
import { strings } from "../../util/language";
import { useSelector } from "react-redux";

const IMAGE = "/images/memory5.png";

const ErrorPage = () => {
  const { language } = useSelector((state: GlobalState) => state.settings);

  const style = {
    backgroundImage: `url(${IMAGE})`,
    backgroundSize: "cover",
  };

  return (
    <div className="loginBackground flex" style={style}>
      <h1 className="error-page-title">
        {strings[language].errorPage.notFound}
      </h1>
    </div>
  );
};

export default ErrorPage;
